// Die einzige Stelle, an der aus einer Zahl oder einem Zeitstempel Text für den Bildschirm wird
// (parts4/00-contract.md, „Formatting"). Keine Komponente baut sich eine Zahl selbst zusammen.
//
// Geschäftsdaten sind 'JJJJ-MM-TT' in Europa/Berlin, Zeitstempel sind ISO-8601 in UTC
// (spec §1, Konventionen). Deshalb wird ein Geschäftsdatum zerlegt und nicht durch `new Date`
// geschickt: `new Date('2026-05-31')` ist Mitternacht UTC und wird westlich von Greenwich zum 30.

/** Was in einer Spalte steht, in der nichts steht. */
export const LEER = '—'

const ZAHL = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const PROZENT = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

const ZEIT = new Intl.DateTimeFormat('de-DE', {
  timeZone: 'Europe/Berlin',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

/**
 * Ganzzahlige Cent → '4.980,00'. Ohne Währungszeichen: das setzt <Betrag>, damit der Euro nicht
 * mit in die Vorlesefassung gerät. Negativ mit echtem Minus (U+2212) statt Bindestrich — in
 * Tabellenziffern ist der Bindestrich zu kurz und rutscht optisch aus der Spalte.
 */
export function eur(cents: number): string {
  if (!Number.isInteger(cents)) throw new RangeError(`eur erwartet ganze Cent, bekam ${cents}`)
  const text = ZAHL.format(Math.abs(cents) / 100)
  return cents < 0 ? `−${text}` : text
}

/** 'JJJJ-MM-TT' → '31.05.2026'. */
export function datum(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso === '') return LEER
  const treffer = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  if (treffer === null) return LEER
  return `${treffer[3]}.${treffer[2]}.${treffer[1]}`
}

/** ISO-Zeitstempel (UTC) → '31.05.2026, 14:03' in Berliner Zeit. */
export function datumZeit(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso === '') return LEER
  const augenblick = new Date(iso)
  if (Number.isNaN(augenblick.getTime())) return LEER
  return ZEIT.format(augenblick)
}

/** Basispunkte → '2,5 %'. 1900 bp sind 19 %. */
export function prozent(bp: number | null | undefined): string {
  if (bp === null || bp === undefined) return LEER
  return `${PROZENT.format(bp / 100)} %`
}

/**
 * Die FinSuites-Kontakt-ID, wie sie auf Rechnung, Beleg und Übersicht steht (spec §6, D5).
 * Fehlt sie, heißt das hier wortgleich wie dort.
 */
export function kontakt(id: string | null | undefined): string {
  if (id === null || id === undefined || id.trim() === '') return 'ohne Kontakt-ID'
  return id.trim()
}
